exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_text_PkuZ0Rv-WvPjPJFX7nRd2 {\n  width: 100%;\n  float: left;\n  clear: both;\n  margin-bottom: 20px;\n}\n\n.IA_dropZones_x9RgsHC0kSp1ZEULsClup {\n  width: 100%;\n  height: 20px;\n  border: 1px dashed #e0e0e0;\n  border-radius: 5px;\n  background-color: #f6f6f6;\n  float: left;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_text": "IA_text_PkuZ0Rv-WvPjPJFX7nRd2",
	"IA_dropZones": "IA_dropZones_x9RgsHC0kSp1ZEULsClup"
};